const LOCAL_API_BASE_URL = 'http://localhost:5274';

function normalizeApiBaseUrl(baseUrl: string): string {
  const withoutTrailingSlash = baseUrl.replace(/\/+$/, '');
  return withoutTrailingSlash.replace(/\/api$/, '');
}

function inferRuntimeApiBaseUrl(): string {
  if (import.meta.env.DEV) {
    return LOCAL_API_BASE_URL;
  }

  if (typeof window === 'undefined') {
    return LOCAL_API_BASE_URL;
  }

  const { protocol, hostname, host } = window.location;

  // In Cloud Run production, frontend and backend use predictable service names.
  if (hostname.startsWith('labcloud-') && hostname.endsWith('.run.app')) {
    return `${protocol}//${hostname.replace(/^labcloud-/, 'labcloud-backend-')}`;
  }

  return `${protocol}//${host}`;
}

function isLocalhostUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    return parsed.hostname === 'localhost' || parsed.hostname === '127.0.0.1';
  } catch {
    return false;
  }
}

export function resolveApiBaseUrl(): string {
  const configuredBaseUrl = (import.meta.env.VITE_API_BASE_URL ?? '').trim();

  const shouldIgnoreConfiguredValue =
    !import.meta.env.DEV &&
    typeof window !== 'undefined' &&
    isLocalhostUrl(configuredBaseUrl) &&
    window.location.hostname !== 'localhost' &&
    window.location.hostname !== '127.0.0.1';

  const baseUrl =
    configuredBaseUrl && !shouldIgnoreConfiguredValue
      ? configuredBaseUrl
      : inferRuntimeApiBaseUrl();

  return normalizeApiBaseUrl(baseUrl);
}
